<div>
  <h3>Slutför order</h3>

  <div class="row">
    <div class="col">
      <button class="styled" (click)="back()">Tillbaka</button>
    </div>
  </div>
</div>
